import React, { useState, useRef } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const ImageUpload = ({ value, onChange, label = "Imagem", className = "" }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError("");
    setUploading(true);
    try {
      const url = await api.uploadImage(file);
      onChange(url);
    } catch (err) {
      setError("Falha no upload.");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={className}>
      {label && <label className="block text-xs font-medium text-gray-400 mb-1.5">{label}</label>}
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-xl overflow-hidden bg-[#0a0f1f] border border-white/10 flex items-center justify-center shrink-0">
          {value ? (
            <img src={value} alt="preview" className="w-full h-full object-cover" />
          ) : (
            <Upload className="w-6 h-6 text-gray-600" />
          )}
        </div>
        <div className="flex-1">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="bf-btn-ghost rounded-lg px-4 py-2 text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-60"
          >
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
            {uploading ? "A carregar..." : "Carregar foto"}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="ou cole um URL de imagem"
            className="bf-input w-full rounded-lg px-3 py-2 text-xs mt-2 placeholder:text-gray-600"
          />
          {error && <p className="text-red-400 text-xs mt-1">{error}</p>}
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
    </div>
  );
};

export default ImageUpload;
